import { render } from "./ProductShowView.vue?vue&type=template&id=0d31f714&scoped=true&ts=true"
import script from "./ProductShowView.vue?vue&type=script&lang=ts"
export * from "./ProductShowView.vue?vue&type=script&lang=ts"

import "./ProductShowView.vue?vue&type=style&index=0&id=0d31f714&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d31f714"]])

export default __exports__